module.exports = __webpack_public_path__ + "static/media/direction.652fab66.jpg";